import React, {memo,} from 'react';
import { useSelector} from 'react-redux';
import { isNormalZhEnCss } from '../../utils';
import styles from './styles.module.scss';

const Index = memo((props) => {
  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { lang } = useSelector(({localesReducer}) => localesReducer.i18n);
  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  };

  const pointersContentMemo = () => {
    const { data } = props.config;

    let style = {};
    if(recReSizeReducer > 1920){
      style = {
        cssOne: {
          marginRight: '290px',
        },
        cssTwo: {
          marginLeft: '190px',
          marginRight: '100px'
        },
        cssThree: {
          marginRight: '290px',
        }
      };
    } else if (recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      style = {
        cssOne: {
          marginRight: '80px',
        },
        cssTwo: {
          marginLeft: '80px',
          marginRight: '0px'
        },
        cssThree: {
          marginRight: '80px',
        }
      };
    } else if (recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      style = {
        cssOne: {
          marginRight: '80px',
        },
        cssTwo: {
          marginLeft: '80px',
          marginRight: '0px'
        },
        cssThree: {
          marginRight: '80px',
        }
      };
    } else if (recReSizeReducer > 750 && recReSizeReducer <= 1024){
      style = {
        cssOne: {
          marginRight: '80px',
        },
        cssTwo: {
          marginLeft: '80px',
          marginRight: '0px'
        },
        cssThree: {
          marginRight: '80px',
        }
      };
    }else{
      style = {
        cssOne: {
          marginRight: 'initial',
        },
        cssTwo: {
          marginLeft: 'initial',
          marginRight: 'initial'
        },
        cssThree: {
          marginRight: 'initial',
        }
      };
    }


    return [
      {
        flexDirection: 'row',
        ...data[0],
        styles: style.cssOne,
      },
      {
        flexDirection: 'row-reverse',
        ...data[1],
        styles: style.cssTwo,
      },
      {
        flexDirection: 'row',
        ...data[2],
        styles: style.cssThree,
      },
    ];
  };


  // 判断是：桌面/移动端
  const isDesktopMobile = () => {
    return (
        <ul className="list">
          {
            pointersContentMemo().map(item => {
              
              const innerRefGet = (innerItem) => {
                  switch(innerItem.no){
                    case '01':
                      return props.config.refs.innerOneRef.innerRef;
                    case '02':
                      return props.config.refs.innerTwoRef.innerRef;
                    default:
                      return props.config.refs.innerThreeRef.innerRef;
                  }
              }

              const innerStylesGet = (innerItem) => {
                  switch(innerItem.no){
                    case '01':
                      return props.config.refs.innerOneRef.innerStyles;
                    case '02':
                      return props.config.refs.innerTwoRef.innerStyles;
                    default:
                      return props.config.refs.innerThreeRef.innerStyles;
                  }
              }

              const flexCss = {
                display: 'flex',
                flexDirection: item.flexDirection,
                justifyContent: 'center',
                alignItems: 'center',
                ...innerStylesGet(item),
              };
                return (
                    <li
                        key={item.no}
                        ref={innerRefGet(item)}
                        style={flexCss}
                        
                    >
                      <div className="left" style={item.styles}>
                          <div className="math">{item.no}</div>
                          <div className="desc">
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                          </div>
                      </div>
                      <div className="right">
                        <img src={item.img} alt="" />
                      </div>
                    </li>
                )
            })
          }
        </ul>
    );
  };

  return (
      <div className={normal()}>
        {isDesktopMobile()}
      </div>
  );
});
export default Index;
